import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import Admin from "./components/Admin";
import User from "./components/User";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserProvider } from "./Context/UserContext";

function App() {
  useEffect(() => {
    // ✅ Limpa apenas uma vez por sessão
    if (!sessionStorage.getItem("cacheCleared")) {
      localStorage.clear();
      if ("caches" in window) {
        caches.keys().then((keys) => {
          keys.forEach((key) => caches.delete(key));
        });
      }
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((regs) => {
          regs.forEach((reg) => reg.unregister());
        });
      }
      sessionStorage.setItem("cacheCleared", "true");
    }
  }, []);

  return (
    <Router>
      <UserProvider>
        <Routes>
          {/* Rota pública */}
          <Route path="/login" element={<Login />} />

          {/* Rota protegida para administradores */}
          <Route element={<ProtectedRoute allowedRoles={[99]} />}>
            <Route path="/admin" element={<Admin />} />
          </Route>

          {/* Rota protegida para usuários comuns e administradores */}
          <Route element={<ProtectedRoute allowedRoles={[1, 99]} />}>
            <Route path="/user" element={<User />} />
          </Route>

          {/* Rota curinga para redirecionar para login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </UserProvider>
    </Router>
  );
}

export default App;
